import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import indexRoutes from "./routes/index";
import firebase from 'firebase/app'
import 'firebase/messaging'
import axios from 'axios';
// import { messaging } from "./init-fcm"

var APRIN = {

    url: 'http://AprinDev.com/',
    title: 'APRIN Engineering',
    colors: {
        white: '#ffffff',
        blueDark: '#56b5de',
        blueLight: '#d6ebf6',
        grayDark: '#030307',
    }

};

if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {

    var args = [
        '\n %c %c %c  ' + APRIN.title + '  %c  %c  ' + APRIN.url + '  %c %c %c \n\n',
        'background: ' + APRIN.colors.blueDark + '; padding:5px 0;',
        'background: ' + APRIN.colors.blueDark + '; padding:5px 0;',
        'color: ' + APRIN.colors.blueLight + '; background: ' + APRIN.colors.grayDark + '; padding:5px 0;',
        'background: ' + APRIN.colors.blueDark + '; padding:5px 0;',
        'background: ' + APRIN.colors.blueLight + '; padding:5px 0;',
        'background: ' + APRIN.colors.blueDark + '; padding:5px 0;',
        'color: ' + APRIN.colors.blueDark + '; background: ' + APRIN.colors.white + '; padding:5px 0;',
        'color: ' + APRIN.colors.blueDark + '; background: ' + APRIN.colors.white + '; padding:5px 0;',
    ];

    window.console.log.apply(console, args);

} else {

    window.console && window.console.log(APRIN.title + ' - ' + APRIN.url);

}
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    messaging;
    async componentDidMount() {
        const initializedFirebaseApp = firebase.initializeApp({
            // Project Settings => Add Firebase to your web app
            apiKey: "AIzaSyAMeD2oHuasCKBcw46yc2P1hG-Pjo_j2IE",
            authDomain: "node-js-notif.firebaseapp.com",
            databaseURL: "https://node-js-notif.firebaseio.com",
            projectId: "node-js-notif",
            storageBucket: "node-js-notif.appspot.com",
            messagingSenderId: "264869805494",
            appId: "1:264869805494:web:8f802ec46aded518c25517"
        });
        this.messaging = initializedFirebaseApp.messaging();
        this.messaging.usePublicVapidKey(
            "BKtIEJ_Cfi7qtOb0ZK_Y6iVJ6z8IGEZatoX6wmwqWGYr8-5Fh89Ho_YMq5LKh-GAjn0cdeVs1JxU8IITctd4f-M"
        );
        this.resetUI();
        this.requestPermission();
        this.messaging.onTokenRefresh(() => {
            this.messaging.getToken().then((refreshedToken) => {

                console.log('Token refreshed.');
                // Indicate that the new Instance ID token has not yet been sent to the
                // app server.
                this.setTokenSentToServer(false);
                // Send Instance ID token to app server.
                this.sendTokenToServer(refreshedToken);
                // [START_EXCLUDE]
                // Display new Instance ID token and clear UI of all previous messages.
                this.resetUI();
                // [END_EXCLUDE]
            }).catch((err) => {
                console.log('Unable to retrieve refreshed token ', err);
            });
        });
        this.messaging.onMessage((payload) => {
            console.log('Message received. ', payload);
            // [START_EXCLUDE]
            // Update the UI to include the received message.
            this.appendMessage(payload);
            // [END_EXCLUDE]
        });
    }


    resetUI =  () => {
        this.messaging.getToken().then((currentToken) => {
            const topic = "all_users";
            // handleTokenRefresh(token)
            axios({
                url: `https://iid.googleapis.com/iid/v1/${currentToken}/rel/topics/${topic}`,
                method: 'post',
                headers: {
                    Authorization: 'key=AAAAPat4fbY:APA91bEeo6ZGZ3Kzj02mYCJODL9VoIHtmbwfFA1KuNwNBbbyR0GmNjUAIn5NJkNoo_cq0tXyGRfcyCws-wsxfn1AJLIoipjDc2xblBvSU8N8zYLLw9H4mqJYsuCGhb3NrCwOf4193hao',
                    "Content-Type": 'application/json'
                }
            }).then(res => {
                console.log(res);
            })
                .catch(err => {
                    console.log(err.Response);

                })
            if (currentToken) {
                this.sendTokenToServer(currentToken);
            } else {
                // Show permission request.
                console.log('No Instance ID token available. Request permission to generate one.');
                // Show permission UI.
                this.setTokenSentToServer(false);
            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
            this.setTokenSentToServer(false);
        });
        // [END get_token]
    }

    sendTokenToServer = (currentToken) => {
        if (!this.isTokenSentToServer()) {
            console.log('Sending token to server...');
            // TODO(developer): Send the current token to your server.
            this.setTokenSentToServer(true);
        } else {
            console.log('Token already sent to server so won\'t send it again ' +
                'unless it changes');
        }

    }

    isTokenSentToServer = () => {
        return window.localStorage.getItem('sentToServer') === '1';
    }
    setTokenSentToServer = (sent) => {
        window.localStorage.setItem('sentToServer', sent ? '1' : '0');
    }

    requestPermission = () => {
        console.log('Requesting permission...');
        // [START request_permission]
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted.');
                // TODO(developer): Retrieve an Instance ID token for use with FCM.
                // [START_EXCLUDE]
                // In many cases once an app has been granted notification permission,
                // it should update its UI reflecting this.
                this.resetUI();
                // [END_EXCLUDE]
            } else {
                console.log('Unable to get permission to notify.');
            }
        });
        // [END request_permission]
    }
    deleteToken = () => {
        // Delete Instance ID token.
        // [START delete_token]
        this.messaging.getToken().then((currentToken) => {
            this.messaging.deleteToken(currentToken).then(() => {
                console.log('Token deleted.');
                this.setTokenSentToServer(false);
                // [START_EXCLUDE]
                // Once token is deleted update UI.
                this.resetUI();
                // [END_EXCLUDE]
            }).catch((err) => {
                console.log('Unable to delete token. ', err);
            });
            // [END delete_token]
        }).catch((err) => {
            console.log('Error retrieving Instance ID token. ', err);
        });

    }




    render() {
        return (
            <BrowserRouter>
                <Routes>
                    {indexRoutes.map((prop, key) => {
                        const Component = prop.component;
                        return <Route path={prop.path} element={<Component />} key={key} />;
                    })}
                </Routes>
            </BrowserRouter>
        );
    }
}

export default App;
